import type { IconSvgObject } from './types';

const FlipLeftIcon: IconSvgObject = [
  ["path", { d: "M12 4C12 3.44772 12.4477 3 13 3H19C20.6569 3 22 4.34315 22 6V18C22 19.6569 20.6569 21 19 21H13C12.4477 21 12 20.5523 12 20V4Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 3H8M5 3C3.34315 3 2 4.34315 2 6M9 21H8M5 21C3.34315 21 2 19.6569 2 18M2 10V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FlipLeftIcon;
